import { convert, RGBA } from 'colvertize'; // https://github.com/Philipp-M/colvertize

// export const  convertToRGBA = hexCode => {
//   if (!hexCode.includes("#")) {
//     let bg = hexCode;
//     if (bg.indexOf("a") == -1) {
//       return bg.replace(")", ", 0.2)").replace("rgb", "rgba");
//     }
//   }

//   let hex = hexCode.replace("#", "");

//   if (hex.length === 3) {
//     hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`;
//   }

//   const r = parseInt(hex.substring(0, 2), 16);
//   const g = parseInt(hex.substring(2, 4), 16);
//   const b = parseInt(hex.substring(4, 6), 16);

//   return `rgba(${r},${g},${b},0.2)`;
// };

export const convertToRGBA = (hexCode) => {
  // converte all to Hext colors without opacity
  return convert(hexCode, 'css-hex', rgbaParseWithOpaacity);
};

function rgbaParseWithOpaacity(c: RGBA): RGBA {
  return {
    r: c.r,
    g: c.g,
    b: c.b,
    a: 0.2,
  };
}
export const datesMaper = (dates, styleParams, recurrences) => {
  for (const date in dates) {
    // Filter the events for the current date
    dates[date] = dates[date]
      .map((o) => {
        if (!o) return null; // Skip null or undefined events

        // Update event color if needed
        o.eventColor =
          o.type !== 'DEFAULT' ? convertToRGBA(o.eventColor) : o.eventColor;

        // Find the relevant key in styleParams.booleans
        const key = Object.keys(styleParams.booleans).find((key) =>
          key.includes(o.calendarId),
        );

        // Check deletion conditions
        if (
          (key && styleParams.booleans[key] === false) || // Key exists but is disabled
          (o.isPrivate && styleParams.booleans.isPrivateEventsShown === false) || // Private event not shown
          o.isVisible === false // Event explicitly marked as not visible
        ) {
          return null; // Mark for removal
        }

        // Otherwise, mark as visible
        o.isVisible = true;
        return o; // Keep the event
      })
      .filter((el) => el !== null); // Remove null values
  }
};
